import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponse} from "src/app/store/base.graphql";

export const institutionFields = `
    id
      institutionUniqueId
      institutionName
      institutionShortform
      institutionPhysicalAddress
      institutionEmail
      institutionPostcode
      institutionWebsite
      institutionPhones
      institutionMapUrl
      institutionLogo
      institutionType
      institutionMinistry {
        id
        ministryUniqueId
        ministryName
      }
      institutionSector {
        id
        sectorUniqueId
        sectorName
        sectorIcon
      }
      institutionRegion {
        id
        regionalUniqueId
        reginalName
        reginalPostcode
        napaId
      }
      institutionDistrict {
        id
        districUniqueId
        districName
        districPostcode
        napaId
        districParentRegion {
          id
          regionalUniqueId
          reginalName
          reginalPostcode
          napaId
        }
      }
      institutionWard {
        id
        wardUniqueId
        wardName
        wardPostcode
        napaId
        wardParentDistric {
          id
          districUniqueId
          districName
          districPostcode
          napaId
        }
      }
      institutionStreet {
        id
        streetUniqueId
        streetName
        streetPostcode
        napaId
        streetParentWard {
          id
          wardUniqueId
          wardName
          wardPostcode
          napaId
        }
      }
      institutionFunctions {
        id
        functionUniqueId
        functionDutyName
        functionCreateddate
        functionIsActive
      }
`;



export const CREATE_INSTITUTION = gql`
    mutation CreateInstitutionMutation($input: InstitutionInputObjects!) {
        createInstitutionMutation(input: $input) {
          response {
            ${baseResponse}
          }
            data {
              ${institutionFields}
            }
        }
    }
`;

export const UPDATE_INSTITUTION = gql`
    mutation UpdateInstitutionMutation($input: InstitutionInputObjects!) {
        updateInstitutionMutation(input: $input) {
            data {
                ${institutionFields}
            }
            response {
                ${baseResponse}
            }
        }
    }
`;

export const GET_ALL_INSTITUTIONS = gql`
    query GetAllInstitutions($filtering: InstitutionFilteringInputObject) {
        getAllInstitutions(filtering: $filtering) {
            data {
                ${institutionFields}
            }
            ${basePageableGraphqlField}
            response {
                ${baseResponse}
            }
        }
    }
`;

export const GET_ALL_INSTITUTIONS_FEW = gql`
    query GetAllInstitutions($filtering: InstitutionFilteringInputObject) {
        getAllInstitutions(filtering: $filtering) {
            data {
              id
              institutionUniqueId
              institutionName
            }
            ${basePageableGraphqlField}
            response {
                ${baseResponse}
            }
        }
    }
`;

export const LOAD_HCMIS_INSTITUTIONS = gql`
mutation LoadHcmisInstitutionsMutation($input: LoadInstitutionInputObjects!) {
  loadHcmisInstitutionsMutation(input: $input) {
    data {
        ${institutionFields}
    }
    response {
        ${baseResponse}
    }
  }
}
`;
